import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
// import treesImg from "../assets/img/trees.jpeg";
import headerImg from "../assets/img/header-img.svg";
import { Prev } from "react-bootstrap/esm/PageItem";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const toRotate = ["Software Developer.", "Web Developer."];
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    // keep track of the full text
    let fulltext = toRotate[i];
    let updatedText = isDeleting
      ? fulltext.substring(0, text.length - 1)
      : fulltext.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fulltext) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <span className="tagline">Welcome to my Portfolio</span>
            <h1>
              {`Hi I'm Miriam a `}
              <span className="wrap"> {text} </span>
            </h1>
            {/* Talk about yourself here */}
            <p>
              Hey there! Welcome to my corner of the internet! I'm Miriam, a
              passionate developer with a knack for turning ideas into digital
              reality. Whether it's crafting sleek websites, developing
              intuitive apps, or diving into the depths of code, I thrive on
              bringing creativity and functionality together. With a blend of
              innovation and attention to detail, I'm here to showcase my
              journey through the ever-evolving world of technology.
            </p>
            <button onClick={() => console.log("connect")}>
              Let's connect
              <ArrowRightCircle size={25} />
            </button>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="Header Img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
